var app = angular.module("leonardo");

var TaskUsersDialog = function($scope) {
  $scope.task = $scope.ngDialogData.task;
};

app.controller('TaskUsersDialog', ['$scope', TaskUsersDialog]);
